<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}: Настройки</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow v-if="settingsText" class="pl-3 pb-3 red" />
                    <CRow v-if="settingsText" class="pl-3 pb-3 red">{{ settingsText }}</CRow>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow class="pl-3 pb-3 h3">Бизнес</CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать партнеру информацию о клиенте
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.admin_access"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Переход в корзину
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.for_cart"
                                />
                            </CCol>
                        </CRow>

                        <CRow class="pl-3 pb-3" />
                        <hr />
                        <CRow class="pl-3 pb-3" />
                        <CRow class="pl-3 pb-3 h3">Карточка товара/услуги</CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Цена товара "От"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.show_min_price"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3" />
                        <hr />
                        <CRow class="pl-3 pb-3" />
                        <CRow class="pl-3 pb-3 h3">Корзина</CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Одноразовые приборы
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.show_cutlery"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Время доставки
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.enabled_delivery_time"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CTextarea
                                    v-model="settings.empty_cart_text"
                                    label="Текст для пустой корзины"
                                    placeholder="Укажите для пустой корзины (не более 255 символов)"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3" />
                        <hr />
                        <CRow class="pl-3 pb-3" />
                        <CRow class="pl-3 pb-3 h3">Форма заказа</CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="12"
                                class="col-form-label">Поле для коментария</CCol>
                            <CCol class="d-flex align-items-center">
                                <template v-for="option in commentOptions">
                                    <CInputRadio
                                        :key="option.id"
                                        class="mb-0 ml-3 mr-0"
                                        inline
                                        name="comment"
                                        :value="option.id"
                                        :checked="selectedComment === option.id"
                                        @update:checked="updateCommentTime"
                                    /> {{ option.title }}
                                </template>
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="12"
                                class="col-form-label">Доставить/Заберу как можно раньше (ко времени)</CCol>
                            <CCol class="d-flex align-items-center">
                                <template v-for="option in deliveryOptions">
                                    <CInputRadio
                                        :key="option.id"
                                        class="mb-0 ml-3 mr-0"
                                        inline
                                        name="time"
                                        :value="option.id"
                                        :checked="selectedDelivery === option.id"
                                        @update:checked="updateDeliveryTime"
                                    /> {{ option.title }}
                                </template>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать только календарь<br>( для записи в сервис )
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.only_calendar"
                                />
                            </CCol>
                        </CRow>

                        <CRow v-if="settings.only_calendar">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Поле время: "Укажите удобные для связи время и дату"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.show_title_tyme_to_contact"
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                В поле "Время" "забрать как можно раньше" / "забрать ко времени"   
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.show_pick_up_from_the_client"
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать текст под формой
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.show_help_text"
                                />
                            </CCol>
                            <CCol>
                                <CTextarea
                                    v-if="settings.show_help_text"
                                    v-model="settings.help_text"
                                    label="Текст под формой"
                                    placeholder="Укажите текст под формой (не более 255 символов)"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import { xssRegEx } from '@/utils/rules';

    export default {
        name: 'EntitySettings',

        components: {
            EntityTabLinks,
        },

        data() {
            return {
                entity: {},
                settings: {
                    id: null,
                    entity_id: null,
                    admin_access: false,
                    show_min_price: false,
                    show_cutlery: false,
                    only_calendar: false,
                    show_title_tyme_to_contact: false,
                    show_pick_up_from_the_client: false,
                    for_cart: false,
                    enabled_delivery_time: false,
                    show_address: false,
                    show_meeting_point: false,
                    show_comment: false,
                    show_large_comment: false,
                    show_delivery_time: false,
                    show_meeting_time: false,
                    show_help_text: false,
                    empty_cart_text: '',
                    help_text: '',
                },
                settingsText: '',
                deliveryOptions: [
                    { id: 1, title: 'Доставить' },
                    { id: 2, title: 'Заберу' },
                    { id: 3, title: 'Не показывать информацию о доствке' },
                ],
                selectedDelivery: 3,
                commentOptions: [
                    { id: 1, title: 'Маленькое' },
                    { id: 2, title: 'Большое' },
                    { id: 3, title: 'Не показывать поле для коментария' },
                ],
                selectedComment: 3,

            };
        },

        computed: {},

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get(`/entities/settings/${id}`)
                .then(resp => {
                    this.settings = resp.data;
                    this.getDeliveryCheck(this.settings);
                    this.getCommentCheck(this.settings);
                })
                .catch(e => {
                    console.log(e);
                    this.settingsText = 'Этот сервис использует стандартные настройки, выберите настройки и нажмите «Сохранить» что бы активировать кастомные настройки.';
                });

        },

        methods: {
            save() {
                if (xssRegEx.test(this.settings.help_text)) {
                    this.$root.$emit('showError', 'Текст под формой содержит недопустимые символы.')
                    return
                }
                Vue.axios
                    .post(`/entities/settings/${this.$route.params.id}`, this.settings)
                    .then(() => this.goBack())
                    .catch(err => this.$root.$emit('showError', 'Ошибка сохранения.'));
            },

            updateDeliveryTime(checked, obj) {
                for(let i = 0; i < this.deliveryOptions.length; i++) {
                    const condidate = this.deliveryOptions.find(option => option.id === +obj.target.value);
                    if (condidate.id === 1) {
                        this.settings.show_delivery_time = true;
                        this.settings.show_meeting_time = false;
                    } else if (condidate.id === 2) {
                        this.settings.show_meeting_time = true;
                        this.settings.show_delivery_time = false;
                    } else {
                        this.settings.show_meeting_time = false;
                        this.settings.show_delivery_time = false;
                    }
                }
            },

            updateCommentTime(checked, obj) {
                for(let i = 0; i < this.commentOptions.length; i++) {
                    const condidate = this.commentOptions.find(option => option.id === +obj.target.value);
                    if (condidate.id === 1) {
                        this.settings.show_comment = true;
                        this.settings.show_large_comment = false;
                    } else if (condidate.id === 2) {
                        this.settings.show_large_comment = true;
                        this.settings.show_comment = false;
                    } else {
                        this.settings.show_large_comment = false;
                        this.settings.show_comment = false;
                    }
                }
            },

            getDeliveryCheck(settings) {
                if (settings.show_delivery_time) {
                    this.selectedDelivery = 1;
                } else if (settings.show_meeting_time) {
                    this.selectedDelivery = 2;
                } else {
                    this.selectedDelivery = 3;
                }
            },

            getCommentCheck(settings) {
                if (settings.show_comment) {
                    this.selectedComment = 1;
                } else if (settings.show_large_comment) {
                    this.selectedComment = 2;
                } else {
                    this.selectedComment = 3;
                }
            },

            updateComment() {
                this.settings.show_comment = false;
                this.settings.show_large_comment = false;
            },

            goBack() {
                const path = `/entities/${this.$route.params.code}/${this.$route.params.id}`;
                this.$router.push({ path });
            },
        },
    };
</script>
<style scoped>
.red {
    color: red;
}
</style>
